(function() { window.GUID_967f7de0_5ff3_46f3_a5f4_375acf563a90 = { getGuid: function() { return "967f7de0-5ff3-46f3-a5f4-375acf563a90"; } }; })();
var CS;
(function (CS) {
    var Enumeration;
    (function (Enumeration) {
        let PromotionDisplayPeriodId;
        (function (PromotionDisplayPeriodId) {
            PromotionDisplayPeriodId[PromotionDisplayPeriodId["Start"] = 1] = "Start";
            PromotionDisplayPeriodId[PromotionDisplayPeriodId["Middle"] = 2] = "Middle";
            PromotionDisplayPeriodId[PromotionDisplayPeriodId["NearEnd"] = 3] = "NearEnd";
            PromotionDisplayPeriodId[PromotionDisplayPeriodId["End"] = 4] = "End";
            PromotionDisplayPeriodId[PromotionDisplayPeriodId["ImmediatelyAfterEnd"] = 5] = "ImmediatelyAfterEnd";
        })(PromotionDisplayPeriodId = Enumeration.PromotionDisplayPeriodId || (Enumeration.PromotionDisplayPeriodId = {}));
    })(Enumeration = CS.Enumeration || (CS.Enumeration = {}));
})(CS || (CS = {}));

//# sourceMappingURL=PromotionDisplayPeriodId.pre.js.map
